import React from "react";
import { Box, Stack, Container, SxProps, styled, AppBar, Toolbar } from "@mui/material";

export interface FullTaskProps {
  children?: React.ReactNode;
  withContainer?: boolean;
  sxContainer?: SxProps;
  sxAppbar?: SxProps;
  sxWrapper?: SxProps;
  sxStack?: SxProps;
  TopBar?: React.ReactNode;
  Subbar?: React.ReactNode;
  Tabbar?: React.ReactNode;
  subbarHeight?: number;
}

const FullTask: React.FC<FullTaskProps> = ({
  children,
  TopBar,
  Subbar,
  Tabbar,
  withContainer = false,
  subbarHeight = 0,
  sxContainer = {},
  sxAppbar = {},
  sxWrapper = {},
  sxStack = {},
}) => {
  const topbarHeight = 64;
  const tabbarHeight = 64;

  let topContentHeight = 0;
  if (TopBar) topContentHeight += topbarHeight;
  if (Subbar) topContentHeight += subbarHeight;
  if (Tabbar) topContentHeight += tabbarHeight;

  return (
    <StyledPageWrapper className="dashboard-content" sx={sxWrapper}>
      {TopBar}
      <StyledAppbar position="absolute" sx={sxAppbar}>
        {Subbar && <StyledToolbar>{Subbar}</StyledToolbar>}
        {Tabbar && <StyledToolbar>{Tabbar}</StyledToolbar>}
      </StyledAppbar>
      <Stack sx={sxStack} direction="row" flex={1}>
        {withContainer ? (
          <StyledContainer topContentHeight={topContentHeight}>
            <Container sx={sxContainer}>{children}</Container>
          </StyledContainer>
        ) : (
          children
        )}
      </Stack>
    </StyledPageWrapper>
  );
};

export default FullTask;

const StyledPageWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  minHeight: "100vh",
  overflowX: "hidden",
  ...theme.helpers(theme).scrollBar,
}));

const StyledContainer = styled(Box, { shouldForwardProp: (prop) => prop !== "topContentHeight" })<{
  topContentHeight?: number;
}>(({ theme, topContentHeight }) => ({
  ...theme.helpers(theme).scrollableContainer,
  ...theme.helpers(theme).scrollBar,
  height: `calc(100vh - ${topContentHeight}px)`,
  marginTop: `${topContentHeight}px`,
}));

const StyledAppbar = styled(AppBar)(({ theme }) => ({
  top: 64,
  left: 0,
  right: 0,
  background: theme.palette.background.paper,
  ".MuiToolbar-root": {
    paddingRight: theme.spacing(3),
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  paddingRight: theme.spacing(3),
  paddingLeft: theme.spacing(3),
}));
